const CopyIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5 6C5 4.89543 5.89543 4 7 4H12C13.1046 4 14 4.89543 14 6V14C14 15.1046 13.1046 16 12 16H7C5.89543 16 5 15.1046 5 14V6Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M10 16.0909V18C10 19.1046 10.8954 20 12 20H17C18.1046 20 19 19.1046 19 18V10C19 8.89543 18.1046 8 17 8H14.9375"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default CopyIcon
